export class HelpViewModel
{
    name:string;
    phoneNumber:string;
    emailAddress:string;
    subject:string;
    body:string;
    /**
     *
     */
      constructor() {
        
        this.name="";
        this.phoneNumber=""
        this.emailAddress="";
        this.body="";
    }
}


// WEBPACK FOOTER //
// ./src/app/VIewModels/TowLocateViewModels/HelpViewModel.ts